import { Box, IconButton, Popover, Stack, TextField, Tooltip } from "@mui/material"
import { useState, useRef } from "react"
import { TruncatedTypography } from "lib/@components/truncated-typography.js"
import Iconify from "minimals-template/components/Iconify.js"

export function EditableTypeCell({ value, placeholder, label, disabled, onConfirm, itemTypeKey, highlight }) {
    const [editValue, setEditValue] = useState(value)
    const anchorRef = useRef(null)
    const [open, setOpen] = useState(false)
    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, width: "100%", minWidth: 0, overflow: "hidden" }}>
            <Tooltip title={`Edit ${label}`}>
                <IconButton
                    ref={anchorRef}
                    size="small"
                    onClick={openPopover}
                    disabled={disabled}
                    data-cy={`type-review-edit-${itemTypeKey || "button"}`}
                >
                    <Iconify icon="mdi:pencil-outline" width={16} />
                </IconButton>
            </Tooltip>
            <Box sx={{ width: 1, minWidth: 0 }}>
                <TruncatedTypography
                    variant="body2"
                    noWrap
                    data-cy={`type-review-cell-${itemTypeKey}`}
                    sx={highlight && value ? { fontWeight: 600 } : undefined}
                >
                    {value || placeholder}
                </TruncatedTypography>
            </Box>
            <Popover
                open={open}
                anchorEl={anchorRef.current}
                onClose={closePopover}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                slotProps={{ paper: { sx: { p: 1.5, minWidth: 300 } } }}
            >
                <Stack direction="row" spacing={1} alignItems="center">
                    <TextField
                        size="small"
                        fullWidth
                        autoFocus
                        value={editValue}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        variant="outlined"
                        placeholder={placeholder}
                        data-cy={`type-review-edit-input-${itemTypeKey}`}
                    />
                    <IconButton
                        aria-label="Confirm edit"
                        size="small"
                        color="success"
                        onMouseDown={confirm}
                        data-cy="type-review-edit-confirm"
                    >
                        <Iconify icon="mdi:check" width={20} />
                    </IconButton>
                    <IconButton
                        aria-label="Cancel edit"
                        size="small"
                        color="error"
                        onMouseDown={closePopover}
                        data-cy="type-review-edit-cancel"
                    >
                        <Iconify icon="mdi:close" width={20} />
                    </IconButton>
                </Stack>
            </Popover>
        </Box>
    )

    function handleChange(e) {
        setEditValue(e.target.value)
    }

    function handleKeyDown(e) {
        if (e.key === "Enter") {
            e.preventDefault()
            confirm()
        }
        if (e.key === "Escape") {
            e.preventDefault()
            closePopover()
        }
    }

    function openPopover() {
        setEditValue(value)
        setOpen(true)
    }

    function confirm() {
        const trimmed = editValue.trim()
        setOpen(false)
        if (trimmed && trimmed !== value && onConfirm) {
            onConfirm(trimmed)
        }
    }

    function closePopover() {
        setOpen(false)
        setEditValue(value)
    }
}
